import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'product_capabilities'

export const dataPointDefinition = {
  retracedId: 'product_capabilities',
  name: 'Product Capabilities',
  description: 'Detailed indication of facilities capabilities',
  meta: {},
  fieldTypeId: 'MULTI_SELECT',
  type: 'TRANSACTIONAL',
  options: [
    {
      key: 'ACID_WASH',
      text: 'Acid wash',
    },
    {
      key: 'ANTI_ACIDIC_COATING',
      text: 'Anti-acidic coating',
    },
    {
      key: 'ANTI_BACTERIAL_ANTI_MICR',
      text: 'Anti-bacterial /anti-micr',
    },
    {
      key: 'BEAD_MANIPULATION',
      text: 'Bead manipulation',
    },
    {
      key: 'BEADING',
      text: 'Beading',
    },
    {
      key: 'BLAKE_WELTING',
      text: 'Blake welting',
    },
    {
      key: 'BRAIDING',
      text: 'Braiding',
    },
    {
      key: 'BROAD_LOOM',
      text: 'Broad loom',
    },
    {
      key: 'BRUSHING',
      text: 'Brushing',
    },
    {
      key: 'BURNOUT_PROCESSING',
      text: 'Burnout processing',
    },
    {
      key: 'CASTING',
      text: 'Casting',
    },
    {
      key: 'CEMENTED',
      text: 'Cemented',
    },
    {
      key: 'CHAMELEON_FINISH',
      text: 'Chameleon finish',
    },
    {
      key: 'CIRCULAR_KNIT',
      text: 'Circular knit',
    },
    {
      key: 'CIRE_FINISH',
      text: 'Cire finish',
    },
    {
      key: 'DEBOSS',
      text: 'Deboss',
    },
    {
      key: 'DECAL_PRINTING',
      text: 'Decal printing',
    },
    {
      key: 'DENIM_WASH',
      text: 'Denim wash',
    },
    {
      key: 'DIGITAL_PRINTING',
      text: 'Digital printing',
    },
    {
      key: 'DIP_DYEING',
      text: 'Dip dyeing',
    },
    {
      key: 'DISCHARGE_PRINTING',
      text: 'Discharge printing',
    },
    {
      key: 'DOWN_PROCESSING',
      text: 'Down processing',
    },
    {
      key: 'DYCOO',
      text: 'Dycoo',
    },
    {
      key: 'EASY_CARE_WASH',
      text: 'Easy care wash',
    },
    {
      key: 'ELECTROPLATING',
      text: 'Electroplating',
    },
    {
      key: 'EMBOSS',
      text: 'Emboss',
    },
    {
      key: 'ENAMEL_SPRAYED_PAINT',
      text: 'Enamel/sprayed paint',
    },
    {
      key: 'ENAMELING',
      text: 'Enameling',
    },
    {
      key: 'ENGRAVING',
      text: 'Engraving',
    },
    {
      key: 'ETCHING',
      text: 'Etching',
    },
    {
      key: 'FABRIC_BONDING',
      text: 'Fabric bonding',
    },
    {
      key: 'FLAT_SCREEN_PRINTING',
      text: 'Flat screen printing',
    },
    {
      key: 'FLOCKING',
      text: 'Flocking',
    },
    {
      key: 'FOIL_PRINTING',
      text: 'Foil printing',
    },
    {
      key: 'GARMENT_DYEING',
      text: 'Garment dyeing',
    },
    {
      key: 'GLAZING',
      text: 'Glazing',
    },
    {
      key: 'GOODYEAR_WELTING',
      text: 'Goodyear welting',
    },
    {
      key: 'HAND_EMBROIDERY',
      text: 'Hand embroidery',
    },
    {
      key: 'HAND_KNIT',
      text: 'Hand knit',
    },
    {
      key: 'HAND_LINKING',
      text: 'Hand linking',
    },
    {
      key: 'HAND_PRINTING',
      text: 'Hand printing',
    },
    {
      key: 'HAND_QUILTING',
      text: 'Hand quilting',
    },
    {
      key: 'HEI_Q_FINISH',
      text: 'Hei-q finish',
    },
    {
      key: 'HOLOGRAM',
      text: 'Hologram',
    },
    {
      key: 'INJECTION_MOULDING',
      text: 'Injection moulding',
    },
    {
      key: 'INSULATION',
      text: 'Insulation',
    },
    {
      key: 'JACQUARD_INTARSIA_KNIT',
      text: 'Jacquard/intarsia knit',
    },
    {
      key: 'LASER_CUT',
      text: 'Laser cut',
    },
    {
      key: 'LEATHER_EMBOSSING',
      text: 'Leather embossing',
    },
    {
      key: 'LEATHER_PERF',
      text: 'Leather perf',
    },
    {
      key: 'LEATHER_PRINTING',
      text: 'Leather printing',
    },
    {
      key: 'MACHINE_SEWN_CONSTRUCTION',
      text: 'Machine sewn construction',
    },
    {
      key: 'MACHINE_COMPUTER_EMBROIDE',
      text: 'Machine/computer embroide',
    },
    {
      key: 'MACHINE_COMPUTER_QUILTING',
      text: 'Machine/computer quilting',
    },
    {
      key: 'METAL_WORKING',
      text: 'Metal working',
    },
    {
      key: 'MOCCASIN_CONSTRUCTION',
      text: 'Moccasin construction',
    },
    {
      key: 'NEEDLE_LOOM',
      text: 'Needle loom',
    },
    {
      key: 'NOVELTY_CABLE_KNIT',
      text: 'Novelty / cable knit',
    },
    {
      key: 'OIL_REPELLENT_FINISH',
      text: 'Oil repellent finish',
    },
    {
      key: 'PEACHED_FINISH',
      text: 'Peached finish',
    },
    {
      key: 'PEEL_STICK',
      text: 'Peel & stick',
    },
    {
      key: 'PIECE_DYE',
      text: 'Piece dye',
    },
    {
      key: 'PIGMENT_DYE',
      text: 'Pigment dye',
    },
    {
      key: 'PIGMENT_PRINTING',
      text: 'Pigment printing',
    },
    {
      key: 'PLATING',
      text: 'Plating',
    },
    {
      key: 'POSTCURE_FINISH',
      text: 'Postcure finish',
    },
    {
      key: 'PRECURE_FINISH',
      text: 'Precure finish',
    },
    {
      key: 'PU_LAMINATION',
      text: 'Pu lamination',
    },
    {
      key: 'PUREPRESS_FINISH',
      text: 'Purepress finish',
    },
    {
      key: 'QUICK_DRY_FINISH',
      text: 'Quick dry finish',
    },
    {
      key: 'REACTIVE_DYE',
      text: 'Reactive dye',
    },
    {
      key: 'REACTIVE_PRINTING',
      text: 'Reactive printing',
    },
    {
      key: 'ROTARY_PRINTING',
      text: 'Rotary printing',
    },
    {
      key: 'RUBBERIZED',
      text: 'Rubberized',
    },
    {
      key: 'SANDBLASTING',
      text: 'Sandblasting',
    },
    {
      key: 'SHUTTLE_LOOM',
      text: 'Shuttle loom',
    },
    {
      key: 'SILICON_MOULDED',
      text: 'Silicon moulded',
    },
    {
      key: 'SILICON_PRINT',
      text: 'Silicon print',
    },
    {
      key: 'SILICONE_WASH',
      text: 'Silicone wash',
    },
    {
      key: 'SIMPLE_KNIT',
      text: 'Simple knit',
    },
    {
      key: 'SLIP_RESISTANT',
      text: 'Slip resistant',
    },
    {
      key: 'STAMPING',
      text: 'Stamping',
    },
    {
      key: 'STONE_CUTTING',
      text: 'Stone cutting',
    },
    {
      key: 'STONE_WASH',
      text: 'Stone wash',
    },
    {
      key: 'SUBLIMATION_PRINTING',
      text: 'Sublimation printing',
    },
    {
      key: 'TANNING_CRUST',
      text: 'Tanning -crust',
    },
    {
      key: 'TANNING_RAW_HIDE',
      text: 'Tanning -raw hide',
    },
    {
      key: 'TANNING_WET_BLUE',
      text: 'Tanning -wet blue',
    },
    {
      key: 'TEFLON_FINISH',
      text: 'Teflon finish',
    },
    {
      key: 'TIE_DYEING',
      text: 'Tie dyeing',
    },
    {
      key: 'TINTING',
      text: 'Tinting',
    },
    {
      key: 'TPU_PRINT',
      text: 'Tpu print',
    },
    {
      key: 'UV_PROTECTION',
      text: 'Uv protection',
    },
    {
      key: 'VULCANIZING',
      text: 'Vulcanizing',
    },
    {
      key: 'WATER_REPELLENT_FINI',
      text: 'Water repellent fini',
    },
    {
      key: 'WATERPROOFING',
      text: 'Waterproofing',
    },
    {
      key: 'WICKING_FINISH',
      text: 'Wicking finish',
    },
    {
      key: 'WOVEN_LEATHER',
      text: 'Woven leather',
    },
    {
      key: 'WRINKLE_FREE_FINISH',
      text: 'Wrinkle free finish',
    },
    {
      key: 'YARN_DYE',
      text: 'Yarn dye',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'string',
          enum: [
            'ACID_WASH',
            'ANTI_ACIDIC_COATING',
            'ANTI_BACTERIAL_ANTI_MICR',
            'BEAD_MANIPULATION',
            'BEADING',
            'BLAKE_WELTING',
            'BRAIDING',
            'BROAD_LOOM',
            'BRUSHING',
            'BURNOUT_PROCESSING',
            'CASTING',
            'CEMENTED',
            'CHAMELEON_FINISH',
            'CIRCULAR_KNIT',
            'CIRE_FINISH',
            'DEBOSS',
            'DECAL_PRINTING',
            'DENIM_WASH',
            'DIGITAL_PRINTING',
            'DIP_DYEING',
            'DISCHARGE_PRINTING',
            'DOWN_PROCESSING',
            'DYCOO',
            'EASY_CARE_WASH',
            'ELECTROPLATING',
            'EMBOSS',
            'ENAMEL_SPRAYED_PAINT',
            'ENAMELING',
            'ENGRAVING',
            'ETCHING',
            'FABRIC_BONDING',
            'FLAT_SCREEN_PRINTING',
            'FLOCKING',
            'FOIL_PRINTING',
            'GARMENT_DYEING',
            'GLAZING',
            'GOODYEAR_WELTING',
            'HAND_EMBROIDERY',
            'HAND_KNIT',
            'HAND_LINKING',
            'HAND_PRINTING',
            'HAND_QUILTING',
            'HEI_Q_FINISH',
            'HOLOGRAM',
            'INJECTION_MOULDING',
            'INSULATION',
            'JACQUARD_INTARSIA_KNIT',
            'LASER_CUT',
            'LEATHER_EMBOSSING',
            'LEATHER_PERF',
            'LEATHER_PRINTING',
            'MACHINE_SEWN_CONSTRUCTION',
            'MACHINE_COMPUTER_EMBROIDE',
            'MACHINE_COMPUTER_QUILTING',
            'METAL_WORKING',
            'MOCCASIN_CONSTRUCTION',
            'NEEDLE_LOOM',
            'NOVELTY_CABLE_KNIT',
            'OIL_REPELLENT_FINISH',
            'PEACHED_FINISH',
            'PEEL_STICK',
            'PIECE_DYE',
            'PIGMENT_DYE',
            'PIGMENT_PRINTING',
            'PLATING',
            'POSTCURE_FINISH',
            'PRECURE_FINISH',
            'PU_LAMINATION',
            'PUREPRESS_FINISH',
            'QUICK_DRY_FINISH',
            'REACTIVE_DYE',
            'REACTIVE_PRINTING',
            'ROTARY_PRINTING',
            'RUBBERIZED',
            'SANDBLASTING',
            'SHUTTLE_LOOM',
            'SILICON_MOULDED',
            'SILICON_PRINT',
            'SILICONE_WASH',
            'SIMPLE_KNIT',
            'SLIP_RESISTANT',
            'STAMPING',
            'STONE_CUTTING',
            'STONE_WASH',
            'SUBLIMATION_PRINTING',
            'TANNING_CRUST',
            'TANNING_RAW_HIDE',
            'TANNING_WET_BLUE',
            'TEFLON_FINISH',
            'TIE_DYEING',
            'TINTING',
            'TPU_PRINT',
            'UV_PROTECTION',
            'VULCANIZING',
            'WATER_REPELLENT_FINI',
            'WATERPROOFING',
            'WICKING_FINISH',
            'WOVEN_LEATHER',
            'WRINKLE_FREE_FINISH',
            'YARN_DYE',
          ],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [],
  sortingId: 38030,
  sectionId: '1.1',
  impactArea: 'About',
  impactAreaId: 'ABOUT',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
